import type {OrgEditPermissions} from '@github-ui/custom-properties-types'
import {human} from '@github-ui/formatters'
import {Link} from '@github-ui/react-core/link'
import {Box, CounterLabel, TabNav, Text} from '@primer/react'
import type {ComponentProps} from 'react'

import {useActiveTab} from '../hooks/use-active-tab'

interface Props {
  definitionsCount: number
  permissions: OrgEditPermissions
}

// Workaround the bug with invalid `activeClassName` prop.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const WrappedLink = ({activeClassName, ...props}: ComponentProps<typeof Link> & {activeClassName?: string}) => (
  <Link {...props} />
)
export function PropertiesPageTabs({definitionsCount, permissions}: Props) {
  const [activeTab, hrefBuilder] = useActiveTab(permissions)
  return (
    <TabNav aria-label="Page selector" sx={{mb: 3, svg: {color: 'fg.muted'}}}>
      <TabNav.Link as={WrappedLink} to={hrefBuilder('properties')} selected={activeTab === 'properties'}>
        <Box sx={{display: 'flex', gap: 2, alignItems: 'center'}}>
          <Text>Properties</Text>
          <CounterLabel>{human(definitionsCount)}</CounterLabel>
        </Box>
      </TabNav.Link>
      <TabNav.Link as={WrappedLink} to={hrefBuilder('set-values')} selected={activeTab === 'set-values'}>
        <Text>Set values</Text>
      </TabNav.Link>
    </TabNav>
  )
}

try{ WrappedLink.displayName ||= 'WrappedLink' } catch {}
try{ PropertiesPageTabs.displayName ||= 'PropertiesPageTabs' } catch {}